import { useState, useEffect } from 'react';

export function useSurveyState() {
  const [currentStep, setCurrentStep] = useState(0);
  const [answers, setAnswers] = useState({});
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [navigationHistory, setNavigationHistory] = useState([0]); // Track visited question indices

  useEffect(() => {
    const saved = localStorage.getItem('survey-progress');
    if (saved) {
      try {
        const data = JSON.parse(saved);
        setAnswers(data.answers || {});
        setCurrentStep(data.currentStep || 0);
        setNavigationHistory(data.navigationHistory || [data.currentStep || 0]);
      } catch (e) {
        console.error('Error loading saved progress:', e);
      }
    }
  }, []);

  useEffect(() => {
    if (!submitted) {
      localStorage.setItem('survey-progress', JSON.stringify({
        answers,
        currentStep,
        navigationHistory
      }));
    }
  }, [answers, currentStep, navigationHistory, submitted]);

  return {
    currentStep,
    setCurrentStep,
    answers,
    setAnswers,
    error,
    setError,
    submitted,
    setSubmitted,
    navigationHistory,
    setNavigationHistory
  };
}
